import declare from "dojo/_base/declare";
import Widget from "csi/form/Widget";

const ColorInPaletteForm = declare(Widget, {
	/**
	 * @override
	 * Combine form with ColorSpecification form
	 */
	_resolveView: function() {
		this.combineForm(false, "Actual", "ColorSpecification", null);
		this.inherited(arguments);
	},
});

export = ColorInPaletteForm;

